import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // Ավելացված է
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faSave, faInfoCircle, faPhoneAlt, faEnvelope, 
    faMapMarkerAlt, faHashtag, faSyncAlt 
} from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { API_BASE } from '../apiConfig';

const AdminStaticContent = ({ tab }) => {
    const { t } = useTranslation(); // Ինիցիալիզացիա
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const [fetchLoading, setFetchLoading] = useState(true);

    const getHeaders = () => ({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'ngrok-skip-browser-warning': 'true'
    });

    useEffect(() => {
        const fetchData = async () => {
            setFetchLoading(true);
            try {
                const res = await fetch(`${API_BASE}/api/${tab}`, {
                    headers: getHeaders()
                });
                const resData = await res.json();
                setData(Array.isArray(resData) ? resData[0] : resData || {});
            } catch (err) {
                console.error("Fetch error:", err);
            } finally {
                setFetchLoading(false);
            }
        };
        fetchData();
    }, [tab]);

    const handleUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const id = data.id || 1;
            const res = await fetch(`${API_BASE}/api/${tab}/${id}`, {
                method: 'PUT',
                headers: getHeaders(),
                body: JSON.stringify(data)
            });

            if (res.ok) {
                alert(t('alert_success'));
            } else if (res.status === 401) {
                alert(t('alert_session_expired'));
            } else {
                alert(t('alert_error_save'));
            }
        } catch (err) {
            console.error("Update error:", err);
            alert(t('alert_conn_error'));
        } finally {
            setLoading(false);
        }
    };

    if (fetchLoading) return <div style={styles.loader}>{t('loading')}</div>;

    return (
        <div style={styles.card}>
            <div style={styles.header}>
                <div style={styles.iconBox}>
                    <FontAwesomeIcon icon={tab === 'about' ? faInfoCircle : faPhoneAlt} />
                </div>
                <div>
                    <h3 style={styles.title}>{tab === 'about' ? t('tab_about') : t('tab_contacts')}</h3>
                    <p style={styles.subtitle}>{t('manage_info_subtitle')}</p>
                </div>
            </div>

            <form onSubmit={handleUpdate} style={styles.form}>
                {tab === 'about' ? (
                    <div style={styles.contentArea}>
                        <div style={styles.inputGroup}>
                            <label style={styles.label}>{t('label_content_hy')}</label>
                            <textarea 
                                style={styles.textarea} 
                                value={data.content || data.text_hy || ''} 
                                onChange={e => setData({...data, content: e.target.value, text_hy: e.target.value})} 
                                placeholder={t('placeholder_about')}
                            />
                        </div>
                        
                        {(data.hasOwnProperty('text_ru') || data.hasOwnProperty('content_ru')) && (
                            <div style={{...styles.inputGroup, marginTop: '20px'}}>
                                <label style={styles.label}>{t('label_content_ru')}</label>
                                <textarea 
                                    style={{...styles.textarea, minHeight: '150px'}} 
                                    value={data.text_ru || data.content_ru || ''} 
                                    onChange={e => setData({...data, text_ru: e.target.value, content_ru: e.target.value})} 
                                />
                            </div>
                        )}
                    </div>
                ) : (
                    <div style={styles.grid}>
                        <div style={styles.inputBox}>
                            <label style={styles.label}><FontAwesomeIcon icon={faPhoneAlt} /> {t('label_phone')}</label>
                            <input style={styles.input} type="text" value={data.phone || ''} onChange={e => setData({...data, phone: e.target.value})} />
                        </div>
                        <div style={styles.inputBox}>
                            <label style={styles.label}><FontAwesomeIcon icon={faEnvelope} /> {t('label_email')}</label>
                            <input style={styles.input} type="email" value={data.email || ''} onChange={e => setData({...data, email: e.target.value})} />
                        </div>
                        <div style={{...styles.inputBox, gridColumn: '1 / -1'}}>
                            <label style={styles.label}><FontAwesomeIcon icon={faMapMarkerAlt} /> {t('label_address')}</label>
                            <input style={styles.input} type="text" value={data.address || ''} onChange={e => setData({...data, address: e.target.value})} />
                        </div>

                        <div style={{...styles.socialSection, gridColumn: '1 / -1'}}>
                            <h4 style={styles.socialTitle}><FontAwesomeIcon icon={faHashtag} /> {t('label_socials')}</h4>
                            <div style={styles.grid}>
                                <div style={styles.inputBox}>
                                    <label style={styles.label}><FontAwesomeIcon icon={faFacebook} color="#1877F2" /> Facebook</label>
                                    <input style={styles.input} type="text" value={data.facebook || ''} onChange={e => setData({...data, facebook: e.target.value})} />
                                </div>
                                <div style={styles.inputBox}>
                                    <label style={styles.label}><FontAwesomeIcon icon={faInstagram} color="#E4405F" /> Instagram</label>
                                    <input style={styles.input} type="text" value={data.instagram || ''} onChange={e => setData({...data, instagram: e.target.value})} />
                                </div>
                                <div style={styles.inputBox}>
                                    <label style={styles.label}><FontAwesomeIcon icon={faWhatsapp} color="#25D366" /> WhatsApp</label>
                                    <input style={styles.input} type="text" value={data.whatsapp || ''} onChange={e => setData({...data, whatsapp: e.target.value})} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div style={styles.footer}>
                    <button type="submit" style={styles.saveBtn} disabled={loading}>
                        <FontAwesomeIcon icon={loading ? faSyncAlt : faSave} spin={loading} style={{marginRight: '10px'}} />
                        {loading ? t('btn_saving') : t('btn_save_all')}
                    </button>
                </div>
            </form>
        </div>
    );
};


// ... Styles remain the same ...
const styles = {
    card: { background: '#fff', borderRadius: '24px', padding: '30px', boxShadow: '0 10px 30px rgba(0,0,0,0.03)', border: '1px solid #F4F7FE' },
    header: { display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '35px' },
    iconBox: { width: '50px', height: '50px', borderRadius: '15px', background: '#F4F7FE', color: '#4318FF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' },
    title: { fontSize: '20px', fontWeight: '800', color: '#1B2559', margin: 0 },
    subtitle: { fontSize: '13px', color: '#A3AED0', margin: '5px 0 0 0' },
    form: { display: 'flex', flexDirection: 'column' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' },
    inputGroup: { display: 'flex', flexDirection: 'column', gap: '10px' },
    inputBox: { display: 'flex', flexDirection: 'column', gap: '8px' },
    label: { fontSize: '13px', fontWeight: '700', color: '#1B2559', display: 'flex', alignItems: 'center', gap: '8px' },
    input: { padding: '14px', borderRadius: '16px', border: '1px solid #E0E5F2', background: '#F4F7FE', outline: 'none', fontSize: '14px' },
    textarea: { padding: '16px', borderRadius: '16px', border: '1px solid #E0E5F2', background: '#F4F7FE', outline: 'none', fontSize: '14px', minHeight: '250px', lineHeight: '1.6', color: '#2B3674' },
    socialSection: { marginTop: '30px', padding: '25px', borderRadius: '20px', background: '#FAFBFF', border: '1px solid #F0F2F8' },
    socialTitle: { margin: '0 0 20px 0', fontSize: '14px', fontWeight: '800', color: '#1B2559', textTransform: 'uppercase', letterSpacing: '0.5px' },
    footer: { marginTop: '40px', display: 'flex', justifyContent: 'flex-end' },
    saveBtn: { background: 'linear-gradient(135deg, #4318FF 0%, #5E37FF 100%)', color: '#fff', border: 'none', padding: '16px 35px', borderRadius: '16px', fontWeight: '700', cursor: 'pointer', boxShadow: '0 10px 20px rgba(67, 24, 255, 0.2)' },
    loader: { textAlign: 'center', padding: '50px', color: '#A3AED0', fontSize: '14px' }
};

export default AdminStaticContent;